var React = require('react');

function ArrowAltInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.01 11.5001H5C4.45 11.5001 4 11.9501 4 12.5001C4 13.0501 4.45 13.5001 5 13.5001H16.01V15.2901C16.01 15.7401 16.55 15.9601 16.86 15.6401L19.64 12.8501C19.83 12.6501 19.83 12.3401 19.64 12.1401L16.86 9.35008C16.55 9.03008 16.01 9.26008 16.01 9.70008V11.5001Z","fill":"currentColor"}));
}

ArrowAltInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"currentColor"};

module.exports = ArrowAltInline;

ArrowAltInline.default = ArrowAltInline;
